import Config from "../Config";
import Requisicao from "./RequisicaoService";

class UFService {
    static async listar() {
        return Requisicao.get(Config.urlBaseApi + 'endereco/uf');
    }    
}

export default UFService;